<h3>{{ variantCatalogDataItem.name }}</h3>
<div class="d-flex flex-row" *ngFor="let item of variantCatalogDataItem.variants">
  <div class="px-2"><input type="checkbox" [id]="item.id" (change)="fireFilterChangeEvent($event, item.id)"
                            [checked]="false"></div>
  <div><label>{{ item.name }}</label></div>
</div>
